import './chip.css';

function Chip() {
  return ( 
    <div className="chip">
      <p className="small-text">Popular</p>
    </div>
   );
}

export default Chip;